module.exports = __webpack_public_path__ + "static/media/arrow.4ba7f36f.svg";